import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    //aosConfig,
    addScollClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';


//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    addScollClass('0px', 'scroll');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    // googleMapInit();


    // initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            $('html,body').animate({ 'scrollTop': ($(this).offset().top - $(this).height()) + 'px' }, 500);
        });




        if ($('.mainContent__aside .submenu li').length <= 4) {
            $('.mainContent__aside .submenu').addClass('toLeft');
        }



        //rotator and sliders
        if ($('.footerNews__slider').length > 0) {
            $('.footerNews__slider').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 10000,
                cssEase: 'linear'
            });

        }
        if ($('.indexC2__gallery').length > 0) {
            $('.indexC2__gallery').slick({
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 2000,
                autoplaySpeed: 3000,
                fade: true,
            });

        }



        //fancybox
        const fcbChck = document.querySelectorAll(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a");

        if (fcbChck.length > 0) {
            let scriptF = document.createElement("script");
            scriptF.setAttribute("src", window.location.origin + "/wp-content/themes/ktm/plugins/fancybox/jquery.fancybox.min.js");
            document.body.appendChild(scriptF);
            let cssF = document.createElement("link");
            cssF.setAttribute("rel", 'stylesheet');
            cssF.setAttribute("href", window.location.origin + "/wp-content/themes/ktm/plugins/fancybox/jquery.fancybox.min.css");
            document.body.appendChild(cssF);

            scriptF.addEventListener("load", () => {

                $(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a").fancybox({
                    'loop': true,
                    'margin': [44, 0],
                    'gutter': 50,
                    'keyboard': true,
                    'arrows': true,
                    'infobar': false,
                    'toolbar': true,
                    'buttons': ["slideShow", "fullScreen", "close"],
                    'idleTime': 4,
                    'protect': false,
                    'modal': false,
                    'animationEffect': "fade",
                    'animationDuration': 600,
                    'transitionEffect': "fade",
                    'transitionDuration': 800,
                    backFocus: false,
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: window.innerWidth > 782 ? "y" : "x" // Vertical (y) or horizontal (x) scrolling
                    }
                });
            });

        }


        $('body *[href*="*!*"]').each(function () {
            $(this).attr('href', $(this).attr('href').replace('*!*', '@'));
        });

        $('body').find(":contains('*!*'):not(:has(*))").each(function () {
            $(this).html($(this).html().replace(/\*!\*/gim, '@'));
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



